import filteredTemplatesSlice from "./filteredTemplatesSlice";

export default filteredTemplatesSlice.reducer;
export { default as filteredTemplatesSlice } from "./filteredTemplatesSlice";
